(function ($) {
    let $searchForm = $('.job-search-form');
    let $ccm_token = $('#ccm-token');
    let $keyword = $('#keyword');
    let $city = $('#city');
    let $postal_code = $('#geo_postal_code');
    let $type_of_childcare = $('#type_of_childcare');
    let $qualifications = $('#qualification');
    let $employmentType = $('#employment_type');
    let $employmentTerm = $('#employment_term');
    let $cityTown = $('#city_town');
    let $kms = $('#kms');
    let $clear = $('#clear');

    $searchForm.on('change', '.search-field', function () {
        doSearch();
    });

    $searchForm.on('submit', function (e) {
        e.preventDefault();
        doSearch();
    });

    $keyword.on('blur', function () {
        doSearch();
    });

    $clear.on('click', function () {
        $searchForm.trigger('reset');
        location.reload();
    });

    let doSearch = function () {
        $.post('/api/job-posts/v1/search',
            {
                ccm_token: $ccm_token.val(),
                keyword: $keyword.val(),
                geo_city: $city.val(),
                geo_postal_code: $postal_code.val(),
                kms: $kms.val(),
                type_of_childcare: $type_of_childcare.val(),
                qualifications: $qualifications.val(),
                employment_type: $employmentType.val(),
                employment_term: $employmentTerm.val(),
                city_town: $cityTown.val()
            },
            function (data, status) {
                $('#search-results').html(data);
            }
        );
    };

})(jQuery);
